import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

const { PlusJdTenantWed } = UrlConfig

// 订单详情
export const getJdOrderList = async options => {
    return request(PlusJdTenantWed.GetJdOrderList, {
      method: METHODS.POST,
      ...options,
    })
  }